<div class="container wow fadeIn top-buffer">
    <div class="container my-5">
        <div class="row justify-content-center">
            <div class="col-lg-6">
                <b-card v-if="submitted" title="Check your email" type="secondary" shadow>
                    <b-card-text>
                        <p>We have sent a temporary password to <strong>{{ form.email }}</strong>.</p>
                        <p>Sign in with it to set a new password and get your test credentials.</p>
                        <router-link to="/login">Go to sign in</router-link>
                    </b-card-text>
                </b-card>

                <b-card v-else title="Create a company account" type="secondary" shadow>
                    <b-card-text>
                        <p class="text-muted">Get test API credentials straight away.</p>
                        <b-form @submit="onSubmit">
                            <b-form-group label="Company Name:" label-for="company-name">
                                <b-form-input id="company-name" v-model="form.companyName" maxlength="200"
                                    placeholder="Enter company name" required></b-form-input>
                            </b-form-group>
                            <b-form-group label="Full Name:" label-for="full-name">
                                <b-form-input id="full-name" v-model="form.fullName" maxlength="200"
                                    placeholder="Enter full name" required></b-form-input>
                            </b-form-group>
                            <b-form-group label="Email Address:" label-for="email">
                                <b-form-input id="email" type="email" v-model="form.email" maxlength="200"
                                    placeholder="Enter email address" required></b-form-input>
                            </b-form-group>
                            <b-button type="submit" variant="primary" class="my-4" :disabled="isLoading">Create Account</b-button>
                        </b-form>
                        <small>Already have an account? <router-link to="/login">Sign in</router-link></small>
                    </b-card-text>
                </b-card>
            </div>
        </div>
    </div>
    <div class="vld-parent">
        <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"></loading>
    </div>
</div>
